import { Component, OnInit } from '@angular/core';
import { BaseCustomFieldViewComponent } from '../../../../../base/form';
import { BehaviorSubject } from 'rxjs';
import { data_get, data_nullify, fallback, OptionalValue } from '../../../../../shared/utils/common';

@Component({
  selector: 'asset-view-variant',
  template: `
    <span class="form-control-plaintext border-bottom form-control-sm pl-2 record-texts long-text pre-wrap-text">
      {{ display$ | async }}
    </span>
  `
})
export class AssetViewVariantComponent extends BaseCustomFieldViewComponent implements OnInit {
  readonly display$ = new BehaviorSubject<OptionalValue<string>>(null);

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.display$.next(fallback(data_nullify(data_get(this.data$.value, 'asset_type_variant_text')), {
      to: () => '--',
    }));
  }
}